<template>
  <!-- 绑定手机号 -->
  <div class='bind-phone'>
    <div v-loading='loading' class='content'>
      <p>绑定手机号</p>
      <input v-model='phone' type='tel' class='input' placeholder='请输入手机号码'>
      <div class='code-wrapper'>
        <input v-model='code' type='tel' class='input-code' placeholder='请输入验证码'>
        <a href='javascript:;' class='btn-code' @click='getCode'>{{ codeText }}</a>
      </div>
      <a href='javascript:;' class='btn-register' @click='bindPhone'>绑定</a>
      <a href='javascript:;' class='btn-cancel' @click='goBack'>取消</a>
    </div>
  </div>
</template>

<script>
import { SMS_CODE, BIND_PHONE } from '@/api'

export default {
  props: ['openid'],
  data() {
    return {
      loading: false,
      phone: '',
      codeText: '获取验证码',
      code: '',
      wait: 59,
    }
  },
  created() {
  },

  methods: {
    // 获取验证码
    getCode() {
      if (this.wait < 59) return

      if (!(/^1[3-9][0-9]{9}$/.test(this.phone))) {
        this.$notify('请输入正确手机号','warning')
        return
      }

      let para = {
        phone: this.phone,
        type: 3, // 3:绑定三方账号
      }
      
      this.loading = true
      SMS_CODE(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify()
          this._countDown()
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 计时
    _countDown() {
      let timer = setInterval( ()=>{
        if (this.wait > 0) {
          this.wait --
          this.codeText = this.wait + 's'
        } else {
          this.codeText = '获取验证码'
          this.wait = 59
          clearInterval(timer)
        }
      },1000)
    },

    // 绑定手机
    bindPhone() {
      if (!(/^1[3-9][0-9]{9}$/.test(this.phone))) {
        this.$notify('请输入正确手机号','warning')
        return
      }
      if ((this.code + '').length !== 6) {
        this.$notify('请输入6位验证码','warning')
        return
      }
      let para = {
        phone: this.phone,
        code: this.code,
        openid: this.openid
      }
      this.loading = true
      BIND_PHONE(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          let payload = {
            key: 'memberType',
            val: 'MEMBER'
          }
          this.$store.commit('updateStrData',payload)
          this.storeToken(res.data.data.token)
          this.$notify('绑定成功')
          this.$emit('bindPhoneSuccess')
        } else {
          this.$notify(res.data.msg, 'error')
        }
      })
    },
    
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.bind-phone {
  min-width: 1200px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .content {
    width: 500px;
    height: 420px;
    box-sizing: border-box;
    background-color: #fff;
    position: absolute;
    top: 25%;
    left: 50%;
    margin-left: -250px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    border-radius: 5px;
    position: relative;
    overflow: hidden;

    p {
      width: 100%;
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      color: #fff;
      background-color: @blue-d;
      text-align: center;
      margin-bottom: 40px;
    }

    .input {
      display: block;
      width: 310px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      font-size: 16px;
      outline: none;
      border: 1px solid #dddddd;
      border-radius: 3px;
      margin: 25px auto 0;
      text-indent: 10px;
    }

    .code-wrapper {
      width: 310px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      border: 1px solid #dddddd;
      border-radius: 3px;
      margin: 25px auto 0;

      .input-code {
        width: 200px;
        height: 36px;
        line-height: 36px;
        line-height: 36px;
        text-indent: 10px;
        outline: none;
        border: none;
        font-size: 16px;
      }

      a.btn-code {
        display: inline-block;
        width: 90px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #acacac;
        font-size: 14px;
        border: 1px solid #dddddd;
        border-radius: 3px;
      }
    }

    .btn-cancel,
    .btn-register {
      display: block;
      width: 310px;
      height: 38px;
      line-height: 38px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      background: #cccccc;
      margin: 0 auto 15px;
      border-radius: 5px;
    }

    .btn-register {
      background: @blue-d;
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BindPhone.vue